import { type BaseButtonProps, Button } from "../button";
import { Icon } from "../icons";
import { useTranslation } from "../localization";
import { cn } from "../utils";

/** Props Interface */
interface FileInspectorLabelProps extends BaseButtonProps {
	itemsLength: number;
}

export function FileInspectorLabel({
	className,
	itemsLength,
	variant = "plain",
	...props
}: FileInspectorLabelProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<Button
			className={cn("gap-1 h-stack w-max", className)}
			icon={
				<Icon
					name="Paperclip"
					className="stroke-accent-500"
				/>
			}
			variant={variant}
			{...props}
		>
			{itemsLength} {t("files.files")}
		</Button>
	);
}
